export const URL = {
  ADMIN: {
    USER_MANAGER: "/admin/user",
    CATEGORY_MANAGER: "/admin/category",
    PODCAST_MANAGER: "/admin/podcast",
    POST_MANAGER: "/admin/post",
    ROLE_MANAGER: "/admin/role",
    PERMISSION_MANAGER: "/admin/permission",
    EMAIL_FOLLOW_MANAGER: "/admin/email-follow",
    ADMIN_DASHBOARD: "/admin",
    UPLOAD_MANAGER: "/admin/upload"
  },
  CLIENT: {
    HOME: "/",
    POST_DETAIL: "/post-detail/:id",
    CATEGORY_DETAIL: "/category-detail/:id",
    LOGIN: "/login",
    REGISTER: "/register",
    POST: "/post",
    PODCAST: "/podcast",
  },
};
